import Image from 'next/image';
import { useSearchParams } from '../../../../hooks/use-search-params';
import { handleTrack } from '../../../../utils/tracker';
import { Button, ButtonVariants } from '../../../Atoms/Button';
import { THEME } from '../../../cms/layout/types';
import { getTextColor } from '../../../cms/layout/util';
import {
  DropdownComponent,
  TDropdownContentIntl,
} from '../InternationalComponents/DropdownComponent';
import {
  HEADER_LABELS,
  PRODUCTS,
  RESOURCES_OPTIONS,
} from '../InternationalComponents/DropdownList.data';
import {
  GeneralDropdown,
  SolutionsDropDown,
} from '../InternationalComponents/DropdownOptions';
import { HeaderStyles } from '../styles';

const DesktopNavBar = ({ theme }: { theme: THEME }): JSX.Element => {
  const { getSearchString } = useSearchParams();
  const textColor = getTextColor(theme);
  const header_labels = HEADER_LABELS;

  const logoSRC =
    theme === THEME.dark
      ? 'https://assets1.cleartax-cdn.com/cleartax/images/1675151654_group1000002542.png'
      : 'https://assets1.cleartax-cdn.com/cleartax/images/1682581587_cleartechlight.png';

  return (
    <>
      <div
        className={`${
          theme === THEME.dark ? 'bg-black' : 'bg-white'
        } p-0 w-full fixed top-0 z-20 font-medium sm:px-0`}
        data-testid="Header"
      >
        <nav className="flex  items-center text-s-14 z-20 md:w-full sm:w-full font-medium wg-container gap-1">
          <div
            className={`sm:w-full inline-flex flex-grow w-auto z-50 sm:flex-row sm:shadow-sm`}
          >
            <a href="/" className="inline-flex items-center py-2">
              <Image
                src={logoSRC}
                alt="clear.tech"
                width={134.7}
                height={35.9}
              />
            </a>
          </div>
          <div
            className={`sm:w-full gap-6 inline-flex flex-grow w-auto z-50 sm:flex-row sm:shadow-sm`}
          >
            <DropdownComponent
              dropdownLabel={header_labels.products}
              dropdownList={PRODUCTS}
              Dropdown={
                GeneralDropdown as unknown as React.FC<TDropdownContentIntl>
              }
              classes="relative"
              hover={true}
              theme={theme}
            />
            <DropdownComponent
              dropdownLabel="Solutions"
              Dropdown={
                SolutionsDropDown as unknown as React.FC<TDropdownContentIntl>
              }
              classes="relative"
              hover={true}
              theme={theme}
            />
            <DropdownComponent
              dropdownLabel={header_labels.resources}
              dropdownList={RESOURCES_OPTIONS}
              Dropdown={
                GeneralDropdown as unknown as React.FC<TDropdownContentIntl>
              }
              classes="relative"
              hover={true}
              theme={theme}
            />
            <a
              className={`${textColor} my-auto`}
              href="/about"
              onClick={(e) =>
                handleTrack({
                  label: 'international_navbar_about',
                  obj: e.target,
                })
              }
            >
              About Us
            </a>
          </div>
          <HeaderStyles
            className={`sm:w-full justify-end inline-flex flex-grow w-auto z-50 md:hidden sm:hidden sm:flex-row sm:shadow-sm`}
          >
            <a
              href={`https://www.clear.tech/contact-us${getSearchString()}`}
              rel="noreferrer"
            >
              <Button
                type="button"
                className="font-medium flex w-auto py-2 px-10 text-white border sm:text-s-12 whitespace-nowrap"
                aria-expanded="true"
                aria-haspopup="true"
                onClick={() => {
                  handleTrack({
                    label: 'contact-us-navbar',
                    obj: this,
                    categoryName: 'clear_tech',
                  });
                }}
                variant={ButtonVariants['clear-tech-green']}
                rounded="3xl"
              >
                {header_labels.get_started}
              </Button>
            </a>
          </HeaderStyles>
        </nav>
      </div>
      <div className="h-12"></div>
    </>
  );
};

export { DesktopNavBar };
